

// import React, { Suspense, useEffect } from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";                  // keep minimal global CSS
// import "./styles/tailwind.css";        // fine
// import "./styles/index.css";           // fine
// import reportWebVitals from "./reportWebVitals";
// // import InitialLoader from "./components/InitialLoader/initialLoader";


// // ⚡ Lazy-load App to reduce initial bundle size
// const App = React.lazy(() => import("./App"));


// // Disable console.log & others in production
// if (process.env.NODE_ENV === "production") {
//   console.log = () => {};
//   console.debug = () => {};
//   console.info = () => {};
//   console.warn = () => {};
//   console.error = () => {};
// }

// // Loader wrapper — removes splash screen once React mounts
// const LoaderWrapper = () => {
//   useEffect(() => {
//     const loader = document.getElementById("initial-loader");
//     if (loader) {
//       //loader.style.opacity = "0";

//       setTimeout(() => {
//         loader.remove();
//       }, 300); // smooth fade-out
//     }
//   }, []);

//   return (
//     <Suspense fallback={null}>
//       <App />
//     </Suspense>
//   );
// };

// // Create the root element for the React app
// ReactDOM.createRoot(document.getElementById("root")).render(<LoaderWrapper />);

// reportWebVitals();


import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/tailwind.css";
import "./styles/index.css";
import reportWebVitals from "./reportWebVitals";

// ⚡ Lazy-load App to reduce initial bundle size
const App = React.lazy(() => import("./App"));

// Disable console.log & others in production
if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.warn = () => {};
  console.error = () => {};
}


ReactDOM.createRoot(document.getElementById("root")).render(
  <Suspense fallback={null}>
    <App />
  </Suspense>
);

reportWebVitals();
